import {
  FormField,
  PanelContainer,
  Toast,
  ToastMessageContentItemType,
  ToastType,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, Link, Text, View} from 'native-base';
import React from 'react';

import {trackEvent} from 'utils/trackEvent';
export interface SigninInfoModuleProps {
  email?: string;
  userName?: string;
}

const TEST_ID_PREFIX = 'signin-info-module';
const RESET_PASSWORD_LINK =
  '/a/verification/password-reset/information?isopenwebview=true';

const SigninInfoModule: React.FC<SigninInfoModuleProps> = ({
  userName,
  email,
}) => {
  const isDesktop = useIsDesktop();

  const onResetPasswordPress = () => {
    trackEvent({event: 'password_reset'});
  };

  return (
    <PanelContainer
      icon="lock"
      panelTitle="SIGN-IN INFORMATION"
      contentMaxWidth="100%">
      <Flex
        mt={2}
        mb={isDesktop ? '36px' : '16px'}
        flexDirection={isDesktop ? 'row' : 'column'}
        width="100%">
        {!userName ? null : (
          <View
            minW={'50%'}
            paddingRight={isDesktop ? 6 : 0}
            marginBottom={isDesktop ? 0 : 4}>
            <View>
              <FormField
                editable={false}
                nativeID={`${TEST_ID_PREFIX}-username`}
                testID={`${TEST_ID_PREFIX}-username`}
                label={'USERNAME'}
                value={userName}
              />
            </View>
          </View>
        )}
        {!email ? null : (
          <View
            pl={userName && isDesktop ? 6 : undefined}
            borderLeftColor={isDesktop ? 'rgba(112, 119, 132, .2)' : undefined}
            borderLeftWidth={userName && isDesktop ? 1 : undefined}
            flexGrow={1}
            flexShrink={1}>
            <View>
              <FormField
                editable={false}
                nativeID={`${TEST_ID_PREFIX}-email`}
                testID={`${TEST_ID_PREFIX}-email`}
                label={'EMAIL ADDRESS'}
                value={email}
              />
            </View>
          </View>
        )}
      </Flex>
      <View flexDirection={isDesktop ? 'row' : 'column'}>
        <Text lineHeight="26px" fontSize={isDesktop ? '16px' : '14px'}>
          Want to update your password?{' '}
        </Text>
        <Link
          isExternal
          href={RESET_PASSWORD_LINK}
          onPress={onResetPasswordPress}
          testID="reset-password-link">
          <Text
            lineHeight="26px"
            underline={true}
            fontSize={isDesktop ? '16px' : '14px'}
            color="caesarRewards">
            Reset my password
          </Text>
        </Link>
      </View>
    </PanelContainer>
  );
};

export default SigninInfoModule;
